import { getServerUri } from './getServerUri'

/** Relative paths → absolute; skip null/empty so we never request `…plnull`. */
export const imageLink = (link) => {
  if (link == null || link === '') return undefined
  if (typeof link === 'string' && link.includes('http')) return link
  return getServerUri() + link
}
